export default "__VITE_ASSET__BYDFOke7__"